import gql from 'graphql-tag';

export const CreateOrUpdateArchivePageNoteMutation = gql`
	mutation CreateOrUpdateArchivePageNoteMutation($pageId: Long!, $archiveNote: String!) {
		createOrUpdateArchivePageNote(pageId: $pageId, archiveNote: $archiveNote)
	}
`;
